import React, { useMemo } from "react"
import { useViewport } from 'components/general/useViewPort'
import MirsTable from "components/general/table/Table"
import { Accordion } from 'react-bootstrap'
import { useUrlFriendlyToParameters, useGetURL } from 'helpers/urlFriendly';
import Label from "components/general/Label"
import Discipline from "components/presentation/Discipline"
import { Link } from "react-router-dom"
import { ALL_URL } from "helpers/utils"

const getConfiguration = (breakPoint, fromPage, isAlphabeticalSort, params) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false
  };
  configuration.sortBy = [{ id: 'Discipline', desc: false }];
  configuration.columns = isMobile ? TableColumnsSM(fromPage, isAlphabeticalSort, params) : TableColumns(fromPage, isAlphabeticalSort, params)
  return configuration;
};

const EntriesDisciplineTable = ({ data, footerData, fromPage }) => {
  let isAlphabeticalSort = !(data?.some(disc => disc?.discipline?.descriptionOrder && disc?.discipline?.descriptionOrder !== 0));
  const { breakPoint } = useViewport();
  const params = useUrlFriendlyToParameters();

  const config = useMemo(() => getConfiguration(breakPoint, fromPage, isAlphabeticalSort, params), [breakPoint, fromPage, isAlphabeticalSort, params]);
  return (
    <MirsTable
      className="table-schedule"
      containerColumnClassName="medals-container-column"
      data={data}
      columns={config.columns}
      keyRow='participant-code'
      initialSortBy={config.sortBy}
      id={`mirs-table-entries`}
      showPagination={true}
      pageSizeCustom={10}
      footerData={footerData}
    />
  )
}

function TableColumns(fromPage, isAlphabeticalSort, params) {
  return (
    [
      ColumnDisciplineRowSpan({ isAlphabeticalSort: isAlphabeticalSort }),
      ColumnGender(fromPage, params)
    ]
  )
}

function TableColumnsSM(fromPage, isAlphabeticalSort, params) {
  return (
    [
      ColumnDisciplineRowSpan({ isAlphabeticalSort: isAlphabeticalSort }),
      ColumnGender(undefined, params)
      // ColumnGender(fromPage)
    ]
  )
}

function ColumnDisciplineRowSpan({ isAlphabeticalSort = true }) {
  return {
    Header: "DisciplineRowSpan",
    enableRowSpan: true,
    relatedId: 'Discipline',
    headerClassName: "text-center w-5 text-nowrap align-middle",
    id: 'HeaderDiscipline',
    columns: [
      ColumnDiscipline({ isAlphabeticalSort: isAlphabeticalSort })
    ]
  }
}

function ColumnDiscipline({ isAlphabeticalSort = true }) {
  // let params = useUrlFriendlyToParameters();
  return (
    {
      Header: <Label data={"HeaderDiscipline"} />,
      sortType: isAlphabeticalSort ? 'absoluteOrderString' : 'absoluteOrderNumber',
      accessor: isAlphabeticalSort ? 'discipline.description' : 'discipline.descriptionOrder',
      // accessor: 'discipline.descriptionOrder',
      className: "text-center",
      headerClassName: "text-center w-5 text-nowrap",
      disableSortBy: false,
      remove: true,
      id: 'Discipline',
      Cell: (props) => {
        const row = props.cell.row.original;
        return (<Discipline hasLink={true} code={row.discipline?.code} description={row.discipline?.description} />);
      }
    }
  )
}

function ColumnGender(fromPage, params) {
  return {
    id: 'Gender',
    Header: <Label data={"HeaderGender"} />,
    headerClassName: "text-center",
    columns: [ColumnCount({ gender: 'M', params: params }), ColumnCount({ gender: 'F', params: params }), ColumnCount({ gender: 'T', fromPage: fromPage, params: params })]
  }
}

function ColumnCount({ gender, fromPage, params }) {
  let _params = { ...params }
  const getURL = useGetURL()

  let labelText = '';
  let accessorVar = '';
  if (gender === "M") {
    labelText = 'HeaderMen';
    accessorVar = 'gender.M'
  } else if (gender === "F") {
    labelText = 'HeaderWomen';
    accessorVar = 'gender.F'
  } else if (gender === "T") {
    labelText = 'HeaderTotal';
    accessorVar = 'gender.T'
  }

  return (
    {
      Header: <Label data={labelText} />,
      accessor: accessorVar,
      className: "text-center",
      headerClassName: "text-center w-5 text-nowrap",
      disableSortBy: false,
      id: gender,
      Cell: (props) => {
        const row = props.cell.row.original;
        if (labelText === 'HeaderTotal') {

          if (fromPage === 'entriesbynoc' || fromPage === 'entriesbydiscipline') {
            _params['mirs_discipline'] = row?.discipline?.code
          } else {
            _params['mirs_noc'] = ALL_URL.ALL_NOC
            _params['mirs_event'] = ALL_URL.ALL_EVENT
          }
          let url = getURL(_params, (fromPage === 'entriesbynoc') ? "nocentriesbyevent" : "entries")

          return <Link to={url} style={{ textDecoration: 'none' }}>{row?.gender?.[gender]}</Link>
        }
        return row?.gender?.[gender];
      }
    }
  )
}

export default EntriesDisciplineTable;


